import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IProjectSectionsResponse, ISection } from "src/api/projects/types";

interface ISectionsState {
  sections: ISection[];
  message: string;
  success: boolean;
}

const initialState: ISectionsState = {
  sections: [],
  message: "",
  success: false
}


const sectionsSlice = createSlice({
  name: "sections",
  initialState,
  reducers: {
    loadSections: (state, action: PayloadAction<IProjectSectionsResponse>) => {
      state.sections = action.payload.data || [];
      state.message = action.payload.message || "";
      state.success = action.payload.success || false;
    },
  },
});

export const {
  loadSections,
} = sectionsSlice.actions;

export default sectionsSlice.reducer;